export default async function fetchImageAndConvertToBlob(imageUrl) {
  const response = await fetch(imageUrl)
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`)
  }
  const blob = await response.blob()
  return blob
}
